export const expandedSidebarDropdownSx = {
  marginTop: 5,
  '& .MuiCollapse-wrapperInner': {
    backgroundColor: 'rgba(6, 24, 36, 0.45)',
    borderRadius: '10px',
    padding: '10px 12px',
  },
} as const
